// extracted by mini-css-extract-plugin
export default {"footDialog":"DialogFooter_footDialog__gfjPp"};